export default __webpack_public_path__ + "static/media/reach.1969e26f.png";